// src/pages/Dashboard/Admin/DetailsAdherents/components/DashboardDataTable.jsx

import React from "react";

export default function DashboardDataTable({
  columns = [],
  rows = [],
  emptyMessage = "Aucune donnée.",
  minWidth = "900px",
}) {
  return (
    <div className="overflow-auto rounded-[24px] border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-950/50">
      <table className="w-full text-sm" style={{ minWidth }}>
        <thead className="sticky top-0 z-10 bg-slate-50 dark:bg-slate-900">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={`px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-slate-600 dark:text-slate-300 ${
                  column.className || ""
                }`}
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
          {rows.length === 0 ? (
            <tr>
              <td
                colSpan={columns.length}
                className="px-4 py-10 text-center text-sm text-slate-500 dark:text-slate-400"
              >
                {emptyMessage}
              </td>
            </tr>
          ) : (
            rows.map((row, rowIndex) => (
              <tr
                key={row?.id || row?.key || rowIndex}
                className="transition hover:bg-slate-50 dark:hover:bg-slate-900"
              >
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={`px-4 py-3 align-top text-slate-700 dark:text-slate-300 ${
                      column.cellClassName || ""
                    }`}
                  >
                    {column.render
                      ? column.render(row, rowIndex)
                      : row?.[column.key] || "—"}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}